import { Table, Tag } from 'antd';
import { DatePickerFilter } from 'components/Filters/DatePickerFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { SelectTableFilter } from 'components/Filters/SelectTableFilter';
import {
  COLUMN_MEDIUM,
  COLUMN_PRE_LARGE,
  COLUMN_SMALL,
  PAGE_SIZE_OPTIONS,
  SCROLL_Y,
} from 'constants/table';
import { checkValue, formatDate } from 'utils';
import {
  bccPaymentsStatusFilters,
  paymentTypes,
  paymentTypesArrFilter,
} from 'utils/handbooks/paymentsHandbook';
import { priceRender, renderWithTooltip } from 'utils/table';

function BccPaymentsTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  filters = {},
  onRowClick,
  onChange,
  onFilter,
}) {
  const { status, type, period } = filters;

  const columns = [
    {
      title: 'Клиент',
      key: 'company_name',
      dataIndex: 'company_name',
      width: 250,
      fixed: 'left',
      render: (value) => renderWithTooltip(value, 40),
    },
    {
      title: '№',
      key: 'id',
      dataIndex: 'id',
      width: 90,
    },
    {
      title: 'Тип',
      key: 'type',
      dataIndex: 'type',
      render: (type) => paymentTypes[type] || '---',
      filterDropdown: () => {
        return (
          <SelectTableFilter
            dataSourse={paymentTypesArrFilter}
            value={type}
            itemKey="value"
            itemValue="text"
            placeholder="Выберите тип"
            getSelectedItem={(type) => onFilter({ type })}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={type} />,
    },
    {
      title: 'Сумма',
      key: 'amount',
      dataIndex: 'amount',
      render: priceRender,
    },
    {
      title: 'Комиссия',
      key: 'fee',
      dataIndex: 'fee',
    },
    {
      title: 'Проведен в банке',
      key: 'accept',
      dataIndex: 'accept',
    },
    {
      width: COLUMN_PRE_LARGE,
      title: 'Статус',
      key: 'status_name',
      dataIndex: 'status_name',
      render: (status) => <Tag>{status}</Tag>,
      filterDropdown: () => {
        return (
          <SelectTableFilter
            dataSourse={bccPaymentsStatusFilters}
            value={status}
            itemKey="value"
            itemValue="text"
            placeholder="Выберите cтатус"
            getSelectedItem={(status) => onFilter({ status })}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={status} />,
    },
    {
      width: COLUMN_SMALL,
      title: 'ИИН',
      key: 'iin',
      dataIndex: 'iin',
    },
    {
      width: COLUMN_MEDIUM,
      title: 'ФИО',
      key: 'fio',
      dataIndex: 'fio',
      render: (value) => renderWithTooltip(value),
    },
    {
      title: 'КБК',
      key: 'kbk',
      dataIndex: 'kbk',
    },
    {
      title: 'КНП',
      key: 'knp',
      dataIndex: 'knp',
    },
    {
      title: 'УГД',
      key: 'tax',
      dataIndex: 'tax',
    },
    {
      title: 'Сервис',
      key: 'srvId',
      dataIndex: 'srvId',
    },
    {
      title: 'Точка',
      key: 'point',
      dataIndex: 'point',
    },
    {
      title: 'Терминал',
      key: 'terminal',
      dataIndex: 'terminal',
      render: checkValue,
    },
    {
      title: 'Реестр',
      key: 'register',
      dataIndex: 'register',
      render: (value) => (value === 1 ? 'Да' : 'Нет'),
    },
    {
      title: 'Создан',
      key: 'create_date',
      dataIndex: 'create_date',
      render: (date) => {
        if (date === checkValue(date)) {
          return formatDate(date, 'DD.MM.YYYY, HH.mm');
        }

        return checkValue(date);
      },
      filterDropdown: () => {
        return (
          <DatePickerFilter
            value={period}
            picker="month"
            format="MM.YYYY"
            returnFormat="YYYY-MM"
            getDate={(period) => onFilter({ period })}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={period} />,
    },
    {
      title: 'Проведен',
      key: 'send_date',
      dataIndex: 'send_date',
      render: (date) => {
        if (date === checkValue(date)) {
          return formatDate(date, 'DD.MM.YYYY, HH.mm');
        }

        return checkValue(date);
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ x: 2300, y: SCROLL_Y }}
      pagination={{
        current,
        total: totalRows,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { BccPaymentsTable };
